import { Type } from 'class-transformer';
import { Model } from './model';
import { Field } from './field';

export type ObjectSchemaCls =
  | 'object_schema'
  | 'integration_schema'
  | 'integration_model'
  | 'unified_schema'
  | 'unified_model';

export class ObjectSchema extends Model {
  name: string;

  description: string | null;

  display_name: string | null;

  @Type(() => ObjectSchemaField)
  fields: ObjectSchemaField[];

  schema_cls: ObjectSchemaCls;

  linked_integration_id: string | null;

  organization_id: string | null;
}

export class ObjectSchemaField extends Field {
  id: string;

  is_enabled: boolean;

  is_end_user_configurable: boolean;

  include_on_update: boolean;

  nested_schema_name: string | null;

  nested_schema_org_id: string | null;
}
